import { createSlice } from "@reduxjs/toolkit";

export const initialState: any = {
  courseData: [],
  singleCourseData: null,
  courseErrorMsg: null,
  loading: false,
  pagination: {},
};

const courseSlice = createSlice({
  name: "course",
  initialState,
  reducers: {
    fetchAllCourses(state, action) {
      state.courseData = action.payload.data.courses;
      state.pagination = action.payload.data.pagination;
    },
    fetchSingleCourse(state, action) {
      state.singleCourseData = action.payload.data;
    },
    courseErrorMsg(state, action) {
      state.courseErrorMsg = action.payload;
    },
    setCourseLoader(state, action) {
      state.loading = action.payload;
    },
    setPagination(state, action) {
      state.pagination = action.payload;
    },
  },
});

export const {
  fetchAllCourses,
  fetchSingleCourse,
  courseErrorMsg,
  setCourseLoader,
  setPagination,
} = courseSlice.actions;

export default courseSlice.reducer;
